import React from 'react';
import { useLocation } from 'react-router-dom';
import ManageEAAgency from './pages/manage-ea-agency/ManageEAAgency';
import ManageAIAgency from './pages/manage-ai-agency/ManageAIAgency';
import ManageMapRequestor from './pages/manage-map-requestor/ManageMapRequestor';
import ManageMarketerPipeline from './pages/manage-marketer-pipeline/ManageMarketerPipeline';

const Organizations = () => {
  const location = useLocation();
  const route = location.pathname.replace('/', '');
  const componentMap = {    
    'manage-ea-agency': ManageEAAgency,
    'manage-ai-agency': ManageAIAgency,
    'manage-map-requestor': ManageMapRequestor,
    'manage-marketer-pipeline': ManageMarketerPipeline,
  };

  const Component = componentMap[route];

  return (
    <div>
      {Component && <Component />}
    </div>
  );
};

export default Organizations;